import React, { useState, useEffect } from "react";
import axios from "axios";
import UserManagementstyle from "../UserStyles/UserTeamManagementstyle.module.css";
import Frame from "../../icons/Frame.svg";
import Trashcan from "../../icons/Trash can.svg"; // Update the import if the file name has changed
import Link from "../../icons/Link.svg"; // Update the import if the file name has changed

const UserTeamManagement = () => {
  const [teams, setTeams] = useState([]);
  const [newPromoterUsername, setNewPromoterUsername] = useState("");
  const [newPromoterDisplayName, setNewPromoterDisplayName] = useState("");
  const [activeDays, setActiveDays] = useState([]);
  const adminId = localStorage.getItem("adminId"); // or use your context/store if you have one

  // Fetch team promoters from the backend on component mount
  useEffect(() => {
    const fetchPromoters = async () => {
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/team/${adminId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        setTeams(response.data.promotersData);
      } catch (error) {
        console.error("Error fetching promoters:", error);
      }
    };
    fetchPromoters();
  }, [adminId]);

  // Function to handle adding a new promoter
  const handleAddPromoter = async (e) => {
    e.preventDefault();
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/add_promoter_team/${adminId}`,
        {
          username: newPromoterUsername,
          display_name: newPromoterDisplayName,
          daysOfWeek: activeDays
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      // Assuming the backend responds with the updated list of promoters
      setTeams(response.data.promotersData);
      setNewPromoterUsername("");
      setNewPromoterDisplayName("");
      setActiveDays([]);
    } catch (error) {
      console.error("Error adding new promoter:", error);
    }
  };

  // Function to handle day toggling for new promoters
  const toggleDay = (day) => {
    setActiveDays((current) =>
      current.includes(day)
        ? current.filter((d) => d !== day)
        : [...current, day]
    );
  };

  // Function to delete a promoter
  const handleDeletePromoter = async (promoterId) => {
    try {
      let token = localStorage.getItem("token");
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/remove_promoter_team/${adminId}`,
        {
          data: { promoterId: promoterId },
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      setTeams(teams.filter((promoter) => promoter.id !== promoterId));
    } catch (error) {
      console.error("Error deleting promoter:", error);
    }
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];

  return (
    <div className={UserManagementstyle.adminTeamManagement}>
      <div className={UserManagementstyle.header1}>
        <div className={UserManagementstyle.headerTitle}>
          Launch a new Event!
        </div>
        <button className={UserManagementstyle.headerButton}>
          <img src={Frame} alt="Launch" />
        </button>
      </div>
      <div className={UserManagementstyle.gridContainer}>
        <div className={UserManagementstyle.sectionStyle}>
          <table>
            <thead>
              <tr>
                <th>Promoters</th>
                <th>Tickets Sold</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {teams.map((promoter) => (
                <tr key={promoter.id}>
                  <td>
                    <div className={UserManagementstyle.promoterDetail}>
                      <img
                        src={promoter.image || "defaultProfileImage.png"}
                        alt="Promoter"
                        className={UserManagementstyle.promoterImage}
                      />
                      <span>{promoter.name}</span>
                    </div>
                  </td>
                  <td>{promoter.totalTicketsSold}</td>
                  <td>
                    <div className={UserManagementstyle.actionButtons}>
                      <button onClick={() => handleDeletePromoter(promoter.id)}>
                        <img src={Trashcan} alt="Delete" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={UserManagementstyle.cardStyle}>
          <h2>Add New Promoter to Team</h2>
          <div className={UserManagementstyle.inputField}>
            <label htmlFor="pattUsername">Enter Promoter PATT Username</label>
            <input
              type="text"
              id="pattUsername"
              placeholder="@PATTusername"
              value={newPromoterUsername}
              onChange={(e) => setNewPromoterUsername(e.target.value)}
            />
          </div>
          <div className={UserManagementstyle.inputField}>
            <label htmlFor="displayName">Enter Promoter Display Name</label>
            <input
              type="text"
              id="displayName"
              placeholder="First Name"
              value={newPromoterDisplayName}
              onChange={(e) => setNewPromoterDisplayName(e.target.value)}
            />
          </div>
          <div className={UserManagementstyle.selectDays}>
            <label>Select Working Days</label>
            <div className={UserManagementstyle.daysOfWeek}>
              {daysOfWeek.map((day) => (
                <button
                  key={day}
                  onClick={() => toggleDay(day)}
                  className={`${UserManagementstyle.dayButton} ${activeDays.includes(day) ? UserManagementstyle.activeDay : ""}`}
                >
                  {day}
                </button>
              ))}
            </div>
            <button
              className={UserManagementstyle.addPromoterButton}
              onClick={handleAddPromoter}
            >
              Add Promoter to the Team
            </button>
          </div>
        </div>
      </div>
      <div className={UserManagementstyle.sectionStyle2}>
        <table>
          <thead>
            <tr>
              <th>Promoter</th>
              <th>Guest List</th>
              <th>Early Birds</th>
              <th>First Offer</th>
              <th>Second Offer</th>
              <th>Third Offer</th>
              <th>Total Sold</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {teams.map((promoter) => (
              <tr key={promoter.id}>
                <td>
                  <div className={UserManagementstyle.promoterDetail}>
                    <img
                      src={promoter.image || Link}
                      alt="Promoter"
                      className={UserManagementstyle.promoterImage}
                    />
                    <span>{promoter.name}</span>
                  </div>
                </td>
                <td>{promoter.guestList}</td>
                <td>{promoter.earlyBirds}</td>
                <td>{promoter.firstOffer}</td>
                <td>{promoter.secondOffer}</td>
                <td>{promoter.thirdOffer}</td>
                <td>{promoter.totalTicketsSold}</td>
                <td>
                  <div className={UserManagementstyle.actionButtons}>
                    <button>
                      <img src={Link} alt="Link" />
                    </button>
                    <button>
                      <img src={Trashcan} alt="Delete" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTeamManagement;
